import { CarrierType, OperationType, VesselArea, WorkInstructionStatus } from '@operations/app/api'
import { convertOperationType } from '@operations/utils/helper'
import { TFnType } from '@tolgee/react'
import { tomTableColumnFilterPresets } from '@tom-ui/ui'
import _ from 'lodash'
import { MRT_ColumnDef, MRT_RowData } from 'material-react-table'

export const workInstructionColumnFilterPresets = {
  ...tomTableColumnFilterPresets,
  vesselAreaSelect: <T extends MRT_RowData>(t: TFnType): Partial<MRT_ColumnDef<T, unknown>> => ({
    filterVariant: 'select',
    filterSelectOptions: [t(_.lowerCase(VesselArea.Hold)), t(_.lowerCase(VesselArea.Deck))],
    filterFn: 'equals',
    enableColumnFilterModes: false,
  }),
  vesselOperationTypeSelect: <T extends MRT_RowData>(
    t: TFnType,
  ): Partial<MRT_ColumnDef<T, unknown>> => ({
    filterVariant: 'select',
    filterSelectOptions: [
      t(convertOperationType(OperationType.Inbound, CarrierType.Vessel)),
      t(convertOperationType(OperationType.Outbound, CarrierType.Vessel)),
    ],
    filterFn: 'equals',
    enableColumnFilterModes: false,
  }),
  trainOperationTypeSelect: <T extends MRT_RowData>(
    t: TFnType,
  ): Partial<MRT_ColumnDef<T, unknown>> => ({
    filterVariant: 'select',
    filterSelectOptions: [
      t(convertOperationType(OperationType.Inbound, CarrierType.Train)),
      t(convertOperationType(OperationType.Outbound, CarrierType.Train)),
    ],
    filterFn: 'equals',
    enableColumnFilterModes: false,
  }),
  truckOperationTypeSelect: <T extends MRT_RowData>(
    t: TFnType,
  ): Partial<MRT_ColumnDef<T, unknown>> => ({
    filterVariant: 'select',
    filterSelectOptions: [
      t(convertOperationType(OperationType.Inbound, CarrierType.Truck)),
      t(convertOperationType(OperationType.Outbound, CarrierType.Truck)),
    ],
    filterFn: 'equals',
    enableColumnFilterModes: false,
  }),
  internalOperationTypeSelect: <T extends MRT_RowData>(
    t: TFnType,
  ): Partial<MRT_ColumnDef<T, unknown>> => ({
    filterVariant: 'select',
    filterSelectOptions: [
      t(convertOperationType(OperationType.Internal)),
      t(convertOperationType(OperationType.Service)),
    ],
    filterFn: 'equals',
    enableColumnFilterModes: false,
  }),
  statusMultiSelect: <T extends MRT_RowData>(t: TFnType): Partial<MRT_ColumnDef<T, unknown>> => ({
    filterVariant: 'multi-select',
    filterSelectOptions: Object.values(WorkInstructionStatus).map(status => ({
      label: (() => t(_.lowerCase(status)))(),
      value: status,
    })),
    filterFn: (row, columnId, filterValue) => {
      if (filterValue?.length <= 0) return true

      const value = row.getValue<string>(columnId)
      const filters = [...filterValue]

      return filters.includes(value)
    },
    enableColumnFilterModes: false,
  }),
  priorityMultiSelect: <T extends MRT_RowData>(t: TFnType): Partial<MRT_ColumnDef<T, unknown>> => ({
    filterVariant: 'multi-select',
    filterSelectOptions: [
      { label: t('high', 'High'), value: 'High' },
      { label: '-', value: '-' },
    ],
    filterFn: (row, columnId, filterValue) => {
      if (filterValue?.length <= 0) return true

      const value = row.getValue<boolean>(columnId) ? 'High' : '-'
      const filters = [...filterValue]

      return filters.includes(value)
    },
    enableColumnFilterModes: false,
  }),
}
